module.exports = require("@xterm-stack/server-core");